import React from "react";
import {Route} from "@/routing/Router";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "@widgets/layout/Breadcrumbs";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";
import {FormattedMessage, useIntl} from "react-intl";
import EditFulfillmentCard from "@widgets/busyness/editor/EditFulfillmentCard";

type Props = {
    route: Route,
};

const BusynessEditor = ({route}: Props) => {
    const intl = useIntl();
    return (
        <>
            <div className={"flex flex-col gap-4"}>
                <PageHeading
                    breadcrumbs={generateBreadcrumbs(route, intl)}
                    title={intl.formatMessage({id: "busynessManagement"})}
                    meta={<LocationPageMeta/>}
                    actionRowHorizontal={false}
                    breakpoints={{md: {actionRowHorizontal: true}}}
                />

                <p className={"w-full text-sm max-w-[600px] text-gray-500 dark:text-slate-400"}>
                    <FormattedMessage id={"busynessManagementExplanation"}/>
                </p>
            </div>

            <EditFulfillmentCard fulfillmentType={"TAKEAWAY"}/>
            <EditFulfillmentCard fulfillmentType={"DELIVERY"}/>
        </>
    );
};

export default BusynessEditor;